import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconExternalFileSharingRestriction = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 21,
	viewBox: "0 0 25 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.40155 20H19.9406C21.0586 20 22.131 19.5551 22.9215 18.7633C23.712 17.9714 24.1563 16.8976 24.1563 15.7778V5.22222C24.1563 4.10243 23.712 3.02842 22.9215 2.23659C22.131 1.44478 21.0586 1 19.9406 1H7.29374C6.17569 1 5.10342 1.44478 4.31285 2.23659C3.52226 3.02842 3.07812 4.10243 3.07812 5.22222V10.5",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 16.8828H11.5391",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 13.6172H5.30469",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.2656 3.22656C17.3885 14.3151 9.84583 14.3047 3.96875 3.22656",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconExternalFileSharingRestriction;
